import { QuickReportConfig } from './quick-reports-dialog';
import { ToolsRoles } from '../utils/roles/client-roles';

export const quickReportsConfig: QuickReportConfig[] = [
  {
    displayName: 'Group',
    description: 'Groups that selected users are members of.',
    reportType: 'userGroupReport',
    role: ToolsRoles.RunGroupExport.value,
    sourceTypeOverride: 'User',
  },
  {
    displayName: 'Approved Email Forwarding',
    description: 'Details approved email forwarding rules for selected users.',
    reportType: 'approvedEmailForwardingReport',
    role: ToolsRoles.RunApprovedEmailForwardingReport.value,
  },
  {
    displayName: 'Archive Users',
    description: 'Shows archived user accounts.',
    reportType: 'archiveUsers',
    role: ToolsRoles.RunArchivedUsersReport.value,
  },
  {
    displayName: 'Email Delegate',
    description: 'Details email delegates assigned to selected users.',
    reportType: 'emailDelegate',
    role: ToolsRoles.RunEmailDelegateReport.value,
  },
  {
    displayName: 'Email Forwarding',
    description: 'Details email forwarding settings for selected users.',
    reportType: 'emailForwarding',
    role: ToolsRoles.RunEmailForwardingReport.value,
  },
  {
    displayName: 'Email Monitor',
    description: 'Shows email monitoring status for selected users.',
    reportType: 'emailMonitor',
    role: ToolsRoles.RunEmailMonitoringReport.value,
  },
  {
    displayName: 'Export Personal Contacts',
    description: 'Exports personal contacts for selected users.',
    reportType: 'exportPersonalContacts',
    role: ToolsRoles.RunExportPersonalContactsReport.value,
  },
  {
    displayName: 'Externally Owned Docs',
    description: 'Lists documents owned by external entities.',
    reportType: 'externallyOwnedDocs',
    role: ToolsRoles.RunExternallyOwnedDocsReport.value,
  },
  {
    displayName: 'Gmail Breakdown Report',
    description: 'Provides detailed breakdown of Gmail usage.',
    reportType: 'gmailBreakdownReport',
    role: ToolsRoles.RunGmailBreakdownReport.value,
  },
  {
    displayName: 'Last Login',
    description: 'Shows last login information for selected users.',
    reportType: 'lastLogin',
    role: ToolsRoles.RunLoginReport.value,
  },
  {
    displayName: 'License Types',
    description: 'Details license types assigned to selected users.',
    reportType: 'licenseTypes',
    role: ToolsRoles.RunLicenseTypes.value,
  },
  {
    displayName: 'Send as Addresses',
    description: 'Details send-as email addresses for selected users.',
    reportType: 'sendAsReport',
    role: ToolsRoles.RunSendAsAddresses.value,
  },
  {
    displayName: 'Site Ownership',
    description: 'Shows site ownership information for selected users.',
    reportType: 'siteOwnership',
    role: ToolsRoles.RunSiteOwnership.value,
  },
  {
    displayName: 'Storage Report',
    description: 'Details storage usage for selected users.',
    reportType: 'storageReport',
    role: ToolsRoles.RunStorageReport.value,
  },
  {
    displayName: 'Super Admin',
    description: 'Shows super admin status for selected users.',
    reportType: 'superAdmin',
    role: ToolsRoles.RunSuperAdminReport.value,
  },
  {
    displayName: 'Suspended User',
    description: 'Lists suspended user accounts.',
    reportType: 'suspendedUser',
    role: ToolsRoles.RunSuspendedReport.value,
  },
  {
    displayName: 'Two Factor Enrolled',
    description: 'Shows two-factor authentication enrollment status.',
    reportType: 'twoFactorEnrolled',
    role: ToolsRoles.RunTwoFactorEnrolled.value,
  },
  {
    displayName: 'Unmodified Documents',
    description: 'Lists documents that have not been modified.',
    reportType: 'unmodifiedDocumentsReport',
    role: ToolsRoles.ViewReports.value,
  },
  {
    displayName: 'User Profile',
    description: 'Shows user profile information.',
    reportType: 'userprofile',
    role: ToolsRoles.RunUserProfileReport.value,
  },
];

export const driveQuickReportsConfig: QuickReportConfig[] = [
  {
    displayName: 'Activities Shared Report My Drive (Public)',
    description: 'Reports on activities from My Drive shared publicly.',
    reportType: 'activitiesSharedReportPublic',
    role: ToolsRoles.RunSharedDriveDocsSharedExternallyReport.value,
    requiresDateRange: true,
  },
  {
    displayName: 'Activities Shared Report (My Drive)',
    description:
      'Tracks activities from My Drive shared within the organization.',
    reportType: 'activitiesSharedReportMyDrive',
    role: ToolsRoles.RunSharedDriveDocsSharedExternallyReport.value,
    requiresDateRange: true,
  },
  {
    displayName: 'Docs Modified Last 14 Days',
    description:
      'Highlights documents that have been edited in the past two weeks.',
    reportType: 'docsModOver14',
    role: ToolsRoles.RunDocsModOver14.value,
  },
  {
    displayName: 'Docs Modified In Last X Days',
    description:
      'Highlights documents edited within the last specified number of days.',
    reportType: 'docsModOverXdays',
    role: ToolsRoles.RunDocsModOverX.value,
    requiresDaysBack: true,
  },
  {
    displayName: 'Docs Over 100MB',
    description: 'Identifies documents larger than 100 megabytes in size.',
    reportType: 'docsOver100MB',
    role: ToolsRoles.RunDocsOver100Mb.value,
  },
  {
    displayName: 'Docs Over 10MB',
    description: 'Reports on documents exceeding 10 megabytes in size.',
    reportType: 'docsOver10MB',
    role: ToolsRoles.RunDocsOver10Mb.value,
  },
  {
    displayName: 'Docs Shared Externally',
    description: 'Lists documents shared with users outside the organization.',
    reportType: 'docsSharedExternally',
    role: ToolsRoles.RunDocsSharedExternally.value,
  },
  {
    displayName: 'Docs Shared Publicly',
    description: 'Tracks documents that have been shared publicly.',
    reportType: 'docsSharedPublicly',
    role: ToolsRoles.RunDocsSharedPublic.value,
  },
  {
    displayName: 'Docs Shared With Groups',
    description: 'Details documents shared with specific groups.',
    reportType: 'docsSharedWithGroups',
    role: ToolsRoles.RunDocsSharedWithGroups.value,
  },
  {
    displayName: 'Docs Shared With Domains',
    description:
      'Reports on documents shared within the organization’s domain.',
    reportType: 'docsSharedWithDomain',
    role: ToolsRoles.RunDocsSharedWithDomain.value,
  },
  {
    displayName: 'Docs Shared With Link',
    description: 'Lists documents accessible via a shareable link.',
    reportType: 'docsSharedWithLink',
    role: ToolsRoles.RunDocsSharedWithLink.value,
  },
  {
    displayName: 'Docs With MP3 Extension',
    description: 'Identifies documents shared via a link.',
    reportType: 'docsWithMP3Ext',
    role: ToolsRoles.RunDocsMP3Ext.value,
  },
  {
    displayName: 'Shared Drives',
    description:
      'Provides an overview of shared drives within the organization.',
    reportType: 'sharedDrives',
    role: ToolsRoles.RunSharedDrivesReport.value,
  },
  {
    displayName: 'Unmodified Documents',
    description:
      'Lists documents that have not been modified in a specified period.',
    reportType: 'unmodifiedDocumentsReport',
    role: ToolsRoles.RunUnmodifiedDocumentsReport.value,
    requiresStartDate: true,
  },
];
